import analytics from '../../analytics';
import { CSSEvent } from '../../types/model';

export function sendPageViewMeta({pageType = 'events', event} : {
  pageType?: string;
  event?: CSSEvent;
}) {
  analytics.sendPageview({
    page_type: pageType,
    local_store: event,
  });
}

export function sendPageView(event: CSSEvent) {
  return sendPageViewMeta({
    pageType: 'events',
    event: event.location.store.storeNo,
  });
}

export function sendSignUpEvent(event: CSSEvent) {
  const storeNo = event.location.store.storeNo;
  analytics.sendEvent(
    {
      label: storeNo,
      action: 'event_signup_begun',
    },
    {
      page_type: 'events',
      local_store: storeNo,
    }
  );
}
